import React from "react";

export default function GanttBar(props) {

  var today = new Date();

  var {
    startDate,
    endDate,

    plannedStart,
    plannedEnd,
    actualStart,
    actualEnd,

    timelineStart,
    weekWidth,
    rowHeight,
    label,

    showStartMarker = true,
    showEndMarker = true,
    ganttMode
  } = props;

  var showPlanned =
    ganttMode === "PLANNED" || ganttMode === "OVERLAY";

  var showActual =
    ganttMode === "ACTUAL" || ganttMode === "OVERLAY";

  var BAR_GRADIENT =
    "linear-gradient(180deg, #4285F4 0%, #1E58B6 100%)";

  function daysBetween(a, b) {
    var ms = b.getTime() - a.getTime();
    return Math.max(0, Math.round(ms / (1000 * 60 * 60 * 24)));
  }

  function getLeftPx(date) {
    var days = daysBetween(timelineStart, date);
    return (days / 7) * weekWidth;
  }

  function getWidthPx(start, end) {
    var days = daysBetween(start, end);
    return Math.max(1, (days / 7) * weekWidth);
  }

  var plannedBarStart = plannedStart || startDate;
  var plannedBarEnd   = plannedEnd   || endDate;

  var actualBarEnd =
    actualEnd || (actualStart ? today : null);

  var baseTop = (rowHeight / 2) - 2.5;

  return (
    <>
      {/* PLANNED (GHOST) BAR */}
      {showPlanned && plannedBarStart && plannedBarEnd && (
        <div
          className="gantt-bar planned"
          style={{
            left: getLeftPx(plannedBarStart),
            width: getWidthPx(plannedBarStart, plannedBarEnd),
            top: ganttMode === "OVERLAY" ? baseTop + 14 : baseTop,
            background: BAR_GRADIENT,
            borderRadius: "10px",
            opacity: ganttMode === "OVERLAY" ? 0.25 : 0.35
          }}
          title={`Planned: ${label}`}
        />
      )}

      {/* ACTUAL BAR */}
      {showActual && actualStart && actualBarEnd && (
        <div
          className="gantt-bar actual"
          style={{
            left: getLeftPx(actualStart),
            width: getWidthPx(actualStart, actualBarEnd),
            top: baseTop,
            background: BAR_GRADIENT,
            borderRadius: "10px",
            opacity: 0.95,
            boxShadow: "0 3px 6px rgba(30,88,182,0.35)"
          }}
          title={`Actual: ${label}`}
        />
      )}
    </>
  );
}
